import { Circ, Power1, TimelineMax, TweenLite } from 'gsap'

export default function emojiBounce(idSelector: string) {
  var tl = new TimelineMax()

  tl

    /* ball bounce up */
    .to(
      idSelector,
      0.5,
      {
        transformOrigin: '50% 50%',
        y: -20,
        ease: Circ.easeOut
        //ease: Power1.easeInOut
      },
      'bounce'
    )

    /* ball bounce down */
    .to(
      idSelector,
      0.4,
      {
        transformOrigin: '50% 50%',
        y: 0,
        ease: Circ.easeIn
        //ease: Power1.easeInOut
      },
      'bounce2'
    )

    /* ball squash */
    .to(
      idSelector,
      0.15,
      {
        transformOrigin: '50% 100%',
        scaleX: 1.3,
        scaleY: 0.6,
        ease: Power1.easeInOut
        //ease: Bounce.easeOut
      },
      'bounce3-=0.04'
    )

    .to(idSelector, 0.15, {
      transformOrigin: '50% 100%',
      scaleX: 1,
      scaleY: 1,
      ease: Power1.easeInOut
    })

    /* ball bounce up */
    .to(
      idSelector,
      0.5,
      {
        transformOrigin: '50% 50%',
        y: -20,
        ease: Circ.easeOut
        //ease: Power1.easeInOut
      },
      'bounce4'
    )

    /* ball bounce down */
    .to(
      idSelector,
      0.4,
      {
        transformOrigin: '50% 50%',
        y: 0,
        ease: Circ.easeIn
        //ease: Power1.easeInOut
      },
      'bounce5'
    )

    /* ball squash */
    .to(
      idSelector,
      0.15,
      {
        transformOrigin: '50% 100%',
        scaleX: 1.3,
        scaleY: 0.6,
        ease: Power1.easeInOut
        //ease: Bounce.easeOut
      },
      'bounce6-=0.04'
    )

    .to(idSelector, 0.15, {
      transformOrigin: '50% 100%',
      scaleX: 1,
      scaleY: 1,
      ease: Power1.easeInOut
    })

  return tl
}
